export class Warning {
    public message: string;

    constructor(message) {
        this.message = message;
    }
}